const translations = {
  en: {
    nav: {
      home: "Home",
      useCases: "Use Cases",
      features: "Features",
      howItWorks: "How It Works",
      pricing: "Pricing",
      howToSetUp: "How to Set Up",
      faq: "FAQ",
      corporate: "Corporate",
      login: "Login",
      getStarted: "Get Started",
      seeDemo: "See Demo",
      reportEmergency: "Report Emergency",
      order: "Order",
      scanLogin: "Scan / Login",
      signUp: "Sign Up",
      profile: "Profile",
      logout: "Logout",
    },
    hero: {
      badge: "India's Road Safety Initiative",
      trustedBadge: "Trusted by families across India",
      title: "Scan. Report. Save a Life.",
      titleAlt: "In an Emergency, This QR Speaks for You",
      subtitle:
        "Turn any vehicle sticker into a life-saving emergency system. One QR scan connects bystanders to your medical info, emergency contacts, and 112 services instantly.",
      subtitleAlt:
        "Stick a tiny QR code on your phone or wear it as a locket. If something happens to you, anyone can scan it to see your blood type, allergies, medications, and emergency contacts — instantly. No app needed.",
      cta: "Get Your QR Sticker",
      scanCta: "I Already Have a QR Code",
      getQRCta: "Get My QR Code",
      ctaSecondary: "See How It Works",
      check1: "Works Without Any App",
      check2: "Loads in Seconds",
      check3: "One-Time Purchase, Lifetime Use",
      impactLine: "Your scan could save a life in the next 15 minutes",
      stat1Value: "112",
      stat1Label: "Direct ERSS Integration",
      stat2Value: "15 min",
      stat2Label: "Avg. Golden Hour Response",
      stat3Value: "25,000",
      stat3Label: "Rah-Veer Reward",
    },
    howItWorks: {
      badge: "THE PROCESS",
      title: "Buy it. Set it. Stay protected.",
      titleShort: "How to Set Up",
      subtitle: "Three simple steps to protect yourself and your family on every journey.",
      setupBadge: "Setup takes under 2 minutes",
      step1Title: "Get your QR sticker",
      step1TitleAlt: "Order Your QR Code",
      step1Desc: "Order your emergency QR sticker starting at just Rs.99. Stick it on your vehicle, helmet, or ID card.",
      step1DescAlt: "We deliver a weatherproof QR sticker (or locket) to your doorstep",
      step1Cta: "Order Now",
      step2Title: "Set up your profile",
      step2TitleAlt: "Add Your Details",
      step2Desc: "Add your blood group, emergency contacts, allergies, and medical conditions. Takes under 2 minutes.",
      step2DescAlt: "Fill in blood type, allergies, medications, and emergency contacts — takes 2 minutes",
      step2Cta: "Setup Guide",
      step3Title: "Stay protected, always",
      step3TitleAlt: "You're Protected",
      step3Desc: "In an emergency, anyone can scan your QR code to access critical info and call 112 instantly.",
      step3DescAlt: "If an emergency happens, anyone who scans the QR code sees your life-saving info instantly",
      step3Cta: "Learn More",
      viewDemo: "See a Live Demo",
    },
    useCases: {
      title: "When Would You Actually Need This?",
      subtitle: "Real situations where a simple QR code can save a life — maybe yours",
      uc1Title: "Road Accidents",
      uc1Desc:
        "You're unconscious after a bike or car accident. The paramedic scans your QR code and immediately knows your blood type is B+, you're allergic to penicillin, and your wife's number. That's the difference this makes.",
      uc1Stat: "Over 1.5 lakh road deaths in India every year",
      uc2Title: "Elderly Parents Living Alone",
      uc2Desc:
        "Your father takes 4 medications daily and lives in another city. If he collapses at the market, the QR locket on his wrist tells anyone exactly who to call and what medicines he's on.",
      uc2Stat: "10 crore+ senior citizens in India",
      uc3Title: "Your Child Gets Lost",
      uc3Desc:
        "Your child wanders off at a crowded mela or mall. A stranger finds them, scans the QR code on their bag or bracelet, and calls you within seconds. No police station, no loudspeaker needed.",
      uc3Stat: "A parent's biggest fear, solved simply",
      uc4Title: "Diabetes, Heart Disease & Allergies",
      uc4Desc:
        "You're diabetic and faint at work. Without this QR code, colleagues might give you sugar water when you actually need insulin. With it, they know exactly what's wrong and who to call.",
      uc4Stat: "7.7 crore+ diabetics in India alone",
      protectCta: "Protect Yourself",
      knowMore: "Know More",
      uc1Detail:
        "India loses over 1.5 lakh lives to road accidents every year. In most cases, the victim is unconscious and unable to communicate critical medical information. An EmergencyQR sticker on your vehicle or helmet allows any bystander or paramedic to instantly access your blood type, allergies, medications, and emergency contacts — no app needed. This bridges the information gap during the Golden Hour and dramatically improves survival chances.",
      uc2Detail:
        "Over 10 crore senior citizens in India live alone or with limited supervision. Many take multiple daily medications and have chronic conditions. A QR code locket or sticker on their person ensures that if they collapse in a market, park, or at home, anyone nearby can scan and immediately know who to call, what medicines they take, and what conditions to watch for. It's peace of mind for you and safety for them.",
      uc3Detail:
        "Every parent's nightmare is losing their child in a crowd. With an EmergencyQR sticker on their school bag, bracelet, or ID card, any good samaritan who finds your child can scan the QR code and call you directly within seconds. No loudspeaker announcements, no police station visits — just a quick scan and an instant connection to the parent.",
      uc4Detail:
        "7.7 crore Indians have diabetes, and millions more live with heart disease, severe allergies, or epilepsy. In an emergency, wrong first aid can be fatal — giving sugar to someone who needs insulin, or aspirin to someone allergic to it. An EmergencyQR sticker ensures that anyone helping you knows exactly what's wrong and what NOT to do, potentially saving your life.",
    },
    features: {
      sectionTitle: "Features",
      sectionSubtitle: "When something goes wrong, the right information at the right time can save a life.",
      f1Title: "Scan & See — That's It",
      f1Desc:
        "A bystander or paramedic points their phone camera at your QR code. Your blood type, allergies, medications, and emergency contacts appear instantly on their screen. No app download, no sign-up, no wasted time.",
      f2Title: "All Your Medical Details in One Place",
      f2Desc:
        "Blood group, daily medications, drug allergies, chronic conditions, doctor's number — everything a hospital needs to treat you correctly, stored in one secure profile that you control.",
      f3Title: "Works 24/7, Even When You Can't",
      f3Desc:
        "Emergencies don't follow a schedule. Whether it's 3 AM or during a holiday, your QR code is always ready. As long as the person scanning has a phone and internet, your information is available.",
      f4Title: "You Decide What's Visible",
      f4Desc:
        "Not comfortable sharing everything publicly? No problem. You choose exactly which details are visible to anyone who scans, and which stay private behind your password. Your data is encrypted and never shared without your permission.",
      f5Title: "One for Every Family Member",
      f5Desc:
        "Get a QR code for your parents, your children, or anyone you worry about. Each person gets their own profile with their own medical details. It's the simplest way to look after the people you love.",
      f6Title: "Zero Apps. Zero Hassle.",
      f6Desc:
        "The person helping you doesn't need to download anything. Every modern smartphone can scan a QR code with its built-in camera. One scan opens a simple webpage with your information — that's how easy it is.",
      f1DetailDesc:
        "One scan shows your blood type, allergies, medications, and emergency contacts — no app download needed. Works on any smartphone browser instantly.",
      f1Cta: "Every second counts. Get instant access to life-saving info.",
      f2DetailDesc:
        "Store blood group, allergies, current medications, chronic conditions, and surgical history. Paramedics see what matters most, instantly.",
      f2Cta: "Your medical history could save your life. Store it securely.",
      f3DetailDesc:
        "Your QR sticker works 24/7, 365 days — rain or shine, day or night. No batteries, no charging, no internet needed on the sticker itself.",
      f3Cta: "Always ready when you need it most.",
      f4DetailDesc:
        "You control exactly what information is visible to others. Toggle visibility for each field. Your data is encrypted and stored securely.",
      f4Cta: "Your data, your rules. Full privacy control.",
      f5DetailDesc:
        "Link multiple QR codes under one family account. Monitor elderly parents, children, and family members — all from one dashboard.",
      f5Cta: "Protect your whole family with one account.",
      f6DetailDesc:
        "No app to download, no account needed for the scanner. Any bystander with a phone camera can scan and see emergency info instantly.",
      f6Cta: "Simple enough for anyone to use in a crisis.",
      buyNow: "Buy Now",
      getYoursCta: "Get Yours",
    },
    landing: {
      activeTitle: "Emergency QR Active",
      viewInfo: "View Information",
      ownerLogin: "Owner Login",
      editInfo: "Edit Information",
      matchHolder: "Match with QR code holder",
      matchHolderHint: "Verify the person matches this photo before sharing any emergency info",
    },
    login: {
      title: "Log In",
      password: "Password",
      passwordRequired: "Password is required",
      forgotPassword: "Forgot Password?",
      loggingIn: "Logging in...",
      alreadyLoggedIn: "You're already logged in",
    },
    forgotPassword: {
      title: "Forgot Password?",
      emailTab: "Email Link",
      phoneTab: "Phone OTP",
    },
    emergencyInfo: {
      title: "Emergency Info",
      previewPublic: "Preview Public View",
      dragReorder: "Drag to reorder. Toggle visibility.",
      noItemsYet: 'No items yet. Click "Add Field" to add information.',
      addField: "Add Field",
    },
    scanner: {
      scanTab: "Scan",
      loginTab: "Login",
      qrIdOrPhone: "QR Code ID or Mobile Number",
      scanTitle: "Scan or Enter QR Code",
    },
    profile: {
      title: "My Profile",
      linkedQR: "Linked QR Codes",
      orderHistory: "Order History",
      noOrders: "No orders yet",
      noQR: "No QR codes linked yet",
    },
    pricing: {
      title: "Pricing",
      oneTimeTab: "QR Codes & Stickers",
      premiumTab: "Premium Membership",
      oneTimeDesc: "Get your QR code stickers and 1 year of premium features included.",
      premiumDesc: "Unlock advanced features: scan notifications, document upload, offline access, and priority support.",
      oneTimeLabel: "one-time",
      orderCta: "Order Now",
      bestValue: "Best Value",
      perYear: "/year",
      plans: {
        individual: {
          name: "Individual",
          desc: "1 QR Code ID with 2 stickers (1x1 inch)",
          f1: "1 unique QR Code ID",
          f2: "2 weatherproof stickers",
          f3: "1 year premium features free",
          f4: "Unlimited emergency info fields",
          f5: "Free shipping",
        },
        family: {
          name: "Family Pack",
          desc: "4 QR Code IDs with 8 stickers (1x1 inch)",
          f1: "4 unique QR Code IDs",
          f2: "8 weatherproof stickers (2 per ID)",
          f3: "1 year premium features free",
          f4: "Protect parents, kids & yourself",
          f5: "Free shipping",
        },
        premium_yearly: {
          name: "Premium",
          desc: "Advanced features for your emergency QR code",
          f1: "Unlimited info fields",
          f2: "Scan notifications",
          f3: "Document upload",
          f4: "Offline caching",
          f5: "Priority support",
        },
        family_yearly: {
          name: "Family Premium",
          desc: "Premium features for up to 4 QR Code IDs",
          f1: "Unlimited info fields (4 QR IDs)",
          f2: "Scan notifications",
          f3: "Document upload",
          f4: "Offline caching",
          f5: "Priority support",
        },
      },
    },
    comingNext: {
      title: "Coming Next",
      subtitle: "More ways to keep you and your family safe.",
      locketTitle: "Premium Metallic Locket",
      locketDesc: "Durable, water-resistant chain with your QR code engraved. Perfect for elderly parents.",
      launchingSoon: "Launching Soon",
    },
    ctaSection: {
      title: "Get Your QR Code Today",
      subtitle: "One-time purchase. Lifetime use. Set up in under 2 minutes.",
      orderButton: "Order",
    },
    public: {
      medicalInfoTitle: "Emergency Info",
      quickActions: "Quick actions",
      moreOptions: "More options",
      reportEmergency: "Report Emergency",
      contactThisPerson: "Contact this person",
      ownerOfLocket: "Owner of this Locket",
      ownerValidationNote: "Verify this is the same person before reading their emergency information below.",
      owner: "Owner",
      editInformation: "Edit Information",
      noDetailsTitle: "No Details Added Yet",
      noDetailsDesc:
        "The owner of this QR code hasn't added any emergency information yet. If you are the owner, log in to add your details.",
      loadingDetails: "Loading Medical Details...",
      errorTitle: "Something Went Wrong",
      footerTagline: "EmergencyQR.in | DPDPA 2023 | 112 India",
      reportDisclaimerIntro:
        "This option should be selected only in case of a real emergency, not for playing around or misuse. False reports may have legal consequences.",
      reportDisclaimerLegal: "यह विकल्प केवल वास्तविक आपातकाल में चुनें। गलत रिपोर्ट के गंभीर परिणाम हो सकते हैं।",
      govRecognitionTitle: "Government recognition & rewards",
      govRecognitionDesc:
        "Genuine reports that help save lives may be eligible for government recognition and rewards under state schemes and Good Samaritan guidelines.",
      understandReport: "I understand, Report",
      logout: "Logout",
    },
    value: {
      badge: "WHY IT MATTERS",
      title: "Every second counts. Every scan saves.",
      subtitle:
        "In India, over 1.5 lakh people die in road accidents annually. The first 60 minutes - the Golden Hour - determine survival. EmergencyQR bridges the gap between accident and ambulance.",
      stat1: "1.5 Lakh+",
      stat1Label: "Annual road deaths in India",
      stat2: "60 min",
      stat2Label: "The critical Golden Hour",
      stat3: "50%",
      stat3Label: "Lives saveable with timely first aid",
    },
    benefits: {
      badge: "THE BENEFITS",
      title: "Safety you can count on.",
      subtitle: "Everything you need to protect yourself and help others on the road.",
      b1Title: "Instant Emergency Access",
      b1Desc: "One scan reveals blood group, allergies, emergency contacts, and medical conditions to any bystander.",
      b2Title: "Direct 112 Integration",
      b2Desc: "Built-in buttons to call ERSS (112), Ambulance (108), and Police (100) with auto-location sharing.",
      b3Title: "Guided First Aid",
      b3Desc: "Step-by-step DRABC protocol and CPR instructions keep bystanders productive during the Golden Hour.",
      b4Title: "Rah-Veer Rewards",
      b4Desc: "Good Samaritans earn Rs.25,000 government reward and complete legal immunity for helping accident victims.",
      b5Title: "Family Dashboard",
      b5Desc: "Manage safety profiles for your entire family - elderly parents, children, and spouse - from one login.",
      b6Title: "DPDPA Compliant",
      b6Desc: "Your medical data is encrypted with AES-256 and protected under India's Digital Personal Data Protection Act.",
    },
    testimonials: {
      badge: "REAL IMPACT",
      title: "Stories that save lives.",
      t1Quote:
        "A bystander scanned my son's QR sticker after his bike accident. The ambulance reached in 12 minutes because they had his blood group and location instantly.",
      t1Name: "Priya Sharma",
      t1Role: "Mother, Delhi",
      t2Quote:
        "As a delivery rider covering 100km daily, this sticker gives me and my family peace of mind. The setup took less than 2 minutes.",
      t2Name: "Ravi Kumar",
      t2Role: "Delivery Partner, Bangalore",
      t3Quote:
        "We deployed EmergencyQR across our 500-vehicle fleet. Response times improved by 40% and our insurance costs dropped significantly.",
      t3Name: "Anita Desai",
      t3Role: "Fleet Manager, Mumbai",
    },
    faq: {
      badge: "Know More",
      title: "Frequently Asked Questions",
      q1: "How does EmergencyQR work?",
      a1: "You receive a durable QR sticker that you place on your vehicle, helmet, or ID card. When scanned by anyone, it displays your emergency medical information, contacts, and provides one-tap access to call 112, 108 (Ambulance), and 100 (Police).",
      q2: "What information should I add to my profile?",
      a2: "We recommend adding your blood group, known allergies, medical conditions (diabetes, heart conditions, etc.), emergency contacts with phone numbers, and your preferred hospital. You control what is visible to scanners.",
      q3: "Is my medical data safe?",
      a3: "All medical data is encrypted with AES-256-GCM encryption at rest. We comply with DPDPA 2023 (India's Data Protection Act). You can control visibility of each piece of information and delete your profile at any time.",
      q4: "What is the Rah-Veer reward?",
      a4: "Under India's Good Samaritan Rules, any bystander who helps an accident victim is eligible for a Rs.25,000 cash reward from the government and complete legal immunity. Our app helps document your Good Samaritan actions for reward verification.",
      q5: "Can I manage profiles for my family?",
      a5: "Yes. Our Family Dashboard lets you manage emergency profiles for elderly parents, children, and your spouse from a single login. Each family member gets their own QR sticker linked to their individual profile.",
      q6: "How much does it cost?",
      a6: "Individual stickers start at just Rs.99 with 12 months of premium features. Family packs (4 stickers) are Rs.249. No hidden fees, no recurring charges for the first year.",
    },
    cta: {
      badge: "START NOW",
      title: "Protect yourself. Help others.",
      subtitle:
        "Join thousands of Indian drivers, riders, and families who have already made their journeys safer with EmergencyQR.",
      button: "Get Your QR Sticker - Rs.99",
    },
    footer: {
      tagline: "India's emergency QR code system for road safety.",
      howItWorks: "How It Works",
      pricing: "Plans",
      corporate: "Corporate",
      about: "About Us",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      copyright: "EmergencyQR. All rights reserved.",
      dpdpa: "DPDPA 2023 Compliant",
      madeIn: "Made in India",
    },
    emergency: {
      reportTitle: "Report Emergency",
      reportSubtitle: "आपातकाल की रिपोर्ट करें",
      viewInfo: "View Information",
      viewInfoHi: "जानकारी देखें",
      ownerLogin: "Owner Login",
      ownerLoginHi: "मालिक लॉगिन",
      step1: "Confirm Location",
      step1Hi: "स्थान की पुष्टि करें",
      step2: "Type of Emergency",
      step2Hi: "आपातकाल का प्रकार",
      step3: "Record Evidence",
      step3Hi: "साक्ष्य रिकॉर्ड करें",
      step4: "Your Phone Number",
      step4Hi: "आपका फोन नंबर",
      medical: "Medical",
      medicalHi: "चिकित्सा",
      accident: "Accident",
      accidentHi: "दुर्घटना",
      fire: "Fire / Other",
      fireHi: "आग / अन्य",
      call112: "Call 112 - National Emergency",
      call112Hi: "112 कॉल करें - राष्ट्रीय आपातकाल",
      call108: "Call 108 - Ambulance",
      call108Hi: "108 कॉल करें - एम्बुलेंस",
      call100: "Call 100 - Police",
      call100Hi: "100 कॉल करें - पुलिस",
      capturingLocation: "Capturing your location...",
      capturingLocationHi: "आपका स्थान प्राप्त कर रहे हैं...",
      locationCaptured: "Location captured successfully",
      locationCapturedHi: "स्थान सफलतापूर्वक प्राप्त हुआ",
      locationFailed: "Could not get location. Please enter manually.",
      locationFailedHi: "स्थान प्राप्त नहीं हो सका। कृपया मैन्युअल रूप से दर्ज करें।",
      tapToReport: "Tap to report emergency",
      tapToReportHi: "आपातकाल की रिपोर्ट करने के लिए टैप करें",
      videoReward:
        "Record a 10-second video to qualify for a FREE QR code, 3 months membership, and government Rah-Veer reward of Rs.25,000",
      videoRewardHi:
        "मुफ्त QR कोड, 3 महीने की सदस्यता और सरकारी राह-वीर पुरस्कार Rs.25,000 के लिए 10 सेकंड का वीडियो रिकॉर्ड करें",
      phoneRequired: "Phone number required for callback and reward claim",
      phoneRequiredHi: "कॉलबैक और पुरस्कार दावे के लिए फोन नंबर आवश्यक",
      submitReport: "Submit Emergency Report",
      submitReportHi: "आपातकालीन रिपोर्ट जमा करें",
      needLocationDesc: "We need your location to dispatch emergency services quickly.",
      needLocationDescHi: "आपातकालीन सेवाओं को तुरंत भेजने के लिए हमें आपका स्थान चाहिए।",
      manualAddressLabel: "Manual Address (optional)",
      manualAddressLabelHi: "पता मैन्युअल रूप से दर्ज करें (वैकल्पिक)",
      manualAddressPlaceholder: "Enter landmark, road name, or area...",
      manualAddressPlaceholderHi: "लैंडमार्क, सड़क का नाम या इलाका दर्ज करें...",
      nextSelectType: "Next - Select Emergency Type",
      nextSelectTypeHi: "अगला - आपातकाल प्रकार चुनें",
      tryAgain: "Try Again",
      tryAgainHi: "पुनः प्रयास करें",
      selectTypeDesc: "Selecting a type will call the number. Tap to call now.",
      selectTypeDescHi: "प्रकार चुनने पर नंबर डायल होगा। अभी कॉल करने के लिए टैप करें।",
      callInitiated: "Call initiated",
      callInitiatedHi: "कॉल शुरू हो गया",
      callInitiatedTo: "Call initiated to",
      callInitiatedToHi: "कॉल शुरू हो गया",
      continueNext: "Continue to next step →",
      continueNextHi: "अगले चरण पर जाएं →",
      recordEvidenceOptional: "Record Evidence (Optional)",
      recordEvidenceOptionalHi: "साक्ष्य रिकॉर्ड करें (वैकल्पिक)",
      earnRewards: "Earn Rewards!",
      earnRewardsHi: "पुरस्कार कमाएं!",
      startRecording: "Start Recording",
      startRecordingHi: "रिकॉर्डिंग शुरू करें",
      stopRecording: "Stop Recording",
      stopRecordingHi: "रिकॉर्डिंग रोकें",
      recordAgain: "Record Again",
      recordAgainHi: "फिर से रिकॉर्ड करें",
      videoRecorded: "Video recorded successfully!",
      videoRecordedHi: "वीडियो सफलतापूर्वक रिकॉर्ड हुआ!",
      tapToStartRecording: "Tap below to start 10-second recording",
      tapToStartRecordingHi: "10 सेकंड की रिकॉर्डिंग शुरू करने के लिए नीचे टैप करें",
      cameraDenied: "Camera access denied or unavailable.",
      cameraDeniedHi: "कैमरा एक्सेस अस्वीकृत या अनुपलब्ध।",
      skip: "Skip",
      skipHi: "छोड़ें",
      next: "Next",
      nextHi: "अगला",
      yourPhoneNumber: "Your Phone Number",
      yourPhoneNumberHi: "आपका फोन नंबर",
      phoneRequiredDesc: "Required for callback verification and reward claim.",
      phoneRequiredDescHi: "कॉलबैक सत्यापन और पुरस्कार दावे के लिए आवश्यक।",
      phoneLabel: "Phone Number",
      phoneLabelHi: "फोन नंबर",
      enterPhonePlaceholder: "Enter 10-digit number",
      enterPhonePlaceholderHi: "10 अंकों का नंबर दर्ज करें",
      phonePrivacyNote: "Your number will only be used for emergency callback and reward verification.",
      phonePrivacyNoteHi: "आपका नंबर केवल आपातकालीन कॉलबैक और पुरस्कार सत्यापन के लिए उपयोग किया जाएगा।",
      submitting: "Submitting...",
      submittingHi: "जमा हो रहा है...",
      reportSubmitted: "Report Submitted",
      reportSubmittedHi: "रिपोर्ट जमा हो गई",
      redirecting: "Redirecting to first aid guide...",
      redirectingHi: "प्राथमिक चिकित्सा मार्गदर्शन पर रीडायरेक्ट हो रहा है...",
      rahVeerEligible: "Rah-Veer Reward Eligible!",
      rahVeerEligibleHi: "राह-वीर पुरस्कार के पात्र!",
      rewardAmount: "Rs.25,000 + Legal Immunity",
      rewardAmountHi: "Rs.25,000 + कानूनी प्रतिरक्षा",
      emergency112: "112 Emergency",
      emergency112Hi: "112 आपातकाल",
      locationUnavailable: "Location unavailable",
      locationUnavailableHi: "स्थान अनुपलब्ध",
      submitError: "Failed to submit report. Please try again.",
      submitErrorHi: "रिपोर्ट जमा करने में विफल। कृपया पुनः प्रयास करें।",
      phoneValidationDigits: "Phone number must be 10 digits",
      phoneValidationDigitsHi: "फोन नंबर 10 अंकों का होना चाहिए",
      phoneValidationStart: "Must start with 6, 7, 8, or 9",
      phoneValidationStartHi: "6, 7, 8 या 9 से शुरू होना चाहिए",
      indiaEmergencyNumbers: "India emergency numbers (भारत आपातकाल नंबर):",
      indiaEmergencyNumbersHi: "भारत आपातकाल नंबर:",
      number112Desc: "112 — National single emergency number (accidents, rescue, any emergency)",
      number108Desc: "108 — Ambulance (medical emergency)",
      number100Desc: "100 — Police",
    },
    rescue: {
      title: "Guided First Aid",
      titleHi: "प्राथमिक चिकित्सा मार्गदर्शन",
      subtitle: "Follow these steps while waiting for the ambulance",
      subtitleHi: "एम्बुलेंस की प्रतीक्षा करते हुए इन चरणों का पालन करें",
      rewardBanner: "You are acting as a Rah-Veer! Eligible for Rs.25,000 reward + legal immunity",
      rewardBannerHi: "आप राह-वीर के रूप में कार्य कर रहे हैं! Rs.25,000 पुरस्कार + कानूनी प्रतिरक्षा के पात्र",
      danger: "DANGER",
      dangerHi: "खतरा",
      dangerDesc: "Check if the area is safe for you to approach. Look for traffic, fire, or electrical hazards.",
      dangerDescHi: "जांचें कि क्या क्षेत्र आपके पास जाने के लिए सुरक्षित है। यातायात, आग या बिजली के खतरों की तलाश करें।",
      response: "RESPONSE",
      responseHi: "प्रतिक्रिया",
      responseDesc: "Gently tap the person's shoulders and ask loudly: 'Are you okay? Can you hear me?'",
      responseDescHi: "धीरे से व्यक्ति के कंधों को थपथपाएं और जोर से पूछें: 'क्या आप ठीक हैं? क्या आप मुझे सुन सकते हैं?'",
      airway: "AIRWAY",
      airwayHi: "वायुमार्ग",
      airwayDesc:
        "Tilt the head back gently and lift the chin to open the airway. Remove any visible obstructions from the mouth.",
      airwayDescHi: "सिर को धीरे से पीछे झुकाएं और ठुड्डी को ऊपर उठाएं। मुंह से दिखाई देने वाली किसी भी रुकावट को हटाएं।",
      breathing: "BREATHING",
      breathingHi: "श्वास",
      breathingDesc:
        "Look at the chest for movement, listen for breath sounds, and feel for air on your cheek for 10 seconds.",
      breathingDescHi: "10 सेकंड तक छाती की गति देखें, सांस की आवाज सुनें, और अपने गाल पर हवा महसूस करें।",
      circulation: "CIRCULATION",
      circulationHi: "रक्त संचार",
      circulationDesc: "Check for severe bleeding. If bleeding, apply firm, continuous pressure with a clean cloth.",
      circulationDescHi: "गंभीर रक्तस्राव की जांच करें। यदि खून बह रहा है, तो साफ कपड़े से मजबूत, निरंतर दबाव लगाएं।",
      cprTitle: "CPR Instructions",
      cprTitleHi: "सीपीआर निर्देश",
      cprDesc:
        "If not breathing: Push hard and fast in the center of the chest. 30 compressions, then 2 rescue breaths. Repeat.",
      cprDescHi: "यदि सांस नहीं चल रही: छाती के बीच में जोर से और तेज दबाएं। 30 दबाव, फिर 2 बचाव श्वास। दोहराएं।",
      bleedingTitle: "Bleeding Control",
      bleedingTitleHi: "रक्तस्राव नियंत्रण",
      bleedingDesc:
        "Apply direct, continuous pressure with a clean cloth. Do NOT remove the cloth. Add more layers if needed.",
      bleedingDescHi: "साफ कपड़े से सीधा, निरंतर दबाव लगाएं। कपड़ा न हटाएं। जरूरत हो तो और परतें जोड़ें।",
      fractureTitle: "Fracture Support",
      fractureTitleHi: "फ्रैक्चर सहायता",
      fractureDesc:
        "Support the injured limb with a wooden block, umbrella, or rolled newspaper. Do NOT try to straighten the limb.",
      fractureDescHi: "घायल अंग को लकड़ी के ब्लॉक, छतरी या मुड़े हुए अखबार से सहारा दें। अंग को सीधा करने की कोशिश न करें।",
      neckWarning:
        "NEVER move an unconscious person without supporting their neck. Spinal injuries can cause permanent paralysis.",
      neckWarningHi:
        "बेहोश व्यक्ति को गर्दन को सहारा दिए बिना कभी न हिलाएं। रीढ़ की हड्डी की चोटें स्थायी पक्षाघात का कारण बन सकती हैं।",
      completed: "Done",
      completedHi: "पूरा हुआ",
      primarySurveyTitle: "Primary Survey (DRABC)",
      primarySurveySubtitle: "Follow each step in order",
      criticalInterventions: "Critical Interventions",
      goldenHourSubtitle: "Golden Hour actions",
      markAsDone: "Mark as Done",
      rewardEligibleShort: "Eligible for Rs.25,000 reward + complete legal immunity",
      completeMoreSteps: "Complete {{n}} more steps for Rah-Veer status",
      disclaimer: "Instructions based on MoHFW & St. John Ambulance protocols. In case of doubt, wait for professional help.",
      poweredBy: "Powered by EmergencyQR.in",
      typeMedical: "Medical Emergency — Focus on CPR & Breathing",
      typeAccident: "Accident — Focus on Bleeding Control",
      typeFire: "Fire/Other — Check for Burns & Bleeding",
      whatsappNotify: "Notify via WhatsApp",
    },
    family: {
      title: "Family Dashboard",
      subtitle: "Manage emergency profiles for your entire family",
      addMember: "Add Family Member",
      memberName: "Member Name",
      relationship: "Relationship",
      qrId: "QR Code ID",
      self: "Self",
      spouse: "Spouse",
      parent: "Parent",
      child: "Child",
      other: "Other",
      noMembers: "No family members added yet. Add your first family member to get started.",
      login: "Family Login",
      register: "Create Family Account",
      email: "Email Address",
      password: "Password",
      phone: "Phone Number",
      name: "Your Name",
    },
    shared: {
      loading: "Loading...",
      loadingHi: "लोड हो रहा है...",
      error: "Something went wrong",
      errorHi: "कुछ गलत हो गया",
      back: "Back",
      next: "Next",
      submit: "Submit",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      poweredBy: "Powered by EmergencyQR.in",
      dpdpaCompliant: "DPDPA 2023 Compliant",
      erssIntegration: "112 India Integration",
    },
  },
  hi: {
    nav: {
      home: "होम",
      useCases: "यूज़ केस",
      features: "फीचर्स",
      howItWorks: "कैसे काम करता है",
      pricing: "मूल्य निर्धारण",
      howToSetUp: "कैसे सेट अप करें",
      faq: "FAQ",
      corporate: "कॉर्पोरेट",
      login: "लॉगिन",
      getStarted: "शुरू करें",
      seeDemo: "डेमो देखें",
      reportEmergency: "आपातकाल रिपोर्ट करें",
      order: "ऑर्डर",
      scanLogin: "स्कैन / लॉगिन",
      signUp: "साइन अप",
      profile: "प्रोफाइल",
      logout: "लॉग आउट",
    },
    hero: {
      badge: "भारत की सड़क सुरक्षा पहल",
      trustedBadge: "भारत भर में परिवारों द्वारा विश्वसनीय",
      title: "स्कैन करें। रिपोर्ट करें। जीवन बचाएं।",
      titleAlt: "आपातकाल में, यह QR कोड आपकी ओर से बोलता है",
      subtitle:
        "किसी भी वाहन स्टिकर को जीवन रक्षक आपातकालीन प्रणाली में बदलें। एक QR स्कैन से राहगीर आपकी चिकित्सा जानकारी, आपातकालीन संपर्क और 112 सेवाओं से तुरंत जुड़ जाते हैं।",
      subtitleAlt:
        "अपने फोन पर एक छोटा QR कोड लगाएं या इसे लॉकेट की तरह पहनें। अगर आपको कुछ होता है, तो कोई भी स्कैन करके आपका ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क तुरंत देख सकता है। ऐप की जरूरत नहीं।",
      cta: "अपना QR स्टिकर प्राप्त करें",
      scanCta: "मेरे पास पहले से QR कोड है",
      getQRCta: "मेरा QR कोड लें",
      ctaSecondary: "देखें कैसे काम करता है",
      check1: "बिना ऐप के काम करता है",
      check2: "सेकंडों में लोड होता है",
      check3: "एक बार खरीदें, जीवन भर इस्तेमाल करें",
    },
    howItWorks: {
      titleShort: "कैसे सेट अप करें",
      setupBadge: "सेटअप 2 मिनट से कम",
      step1TitleAlt: "अपना QR कोड ऑर्डर करें",
      step1DescAlt: "हम आपके दरवाजे पर वाटरप्रूफ QR स्टिकर (या लॉकेट) डिलीवर करते हैं",
      step2TitleAlt: "अपनी जानकारी जोड़ें",
      step2DescAlt: "ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क भरें — 2 मिनट लगते हैं",
      step3TitleAlt: "आप सुरक्षित हैं",
      step3DescAlt: "अगर आपातकाल होता है, जो कोई भी QR कोड स्कैन करता है वह तुरंत आपकी जान बचाने वाली जानकारी देखता है",
      viewDemo: "लाइव डेमो देखें",
    },
    useCases: {
      title: "आपको वाकई इसकी कब ज़रूरत पड़ेगी?",
      subtitle: "वास्तविक स्थितियाँ जहाँ एक साधारण QR कोड जान बचा सकता है — शायद आपकी",
      uc1Title: "सड़क दुर्घटनाएँ",
      uc1Desc:
        "बाइक या कार दुर्घटना के बाद आप बेहोश हैं। पैरामेडिक आपका QR कोड स्कैन करता है और तुरंत जानता है कि आपका ब्लड ग्रुप B+ है, आपको पेनिसिलिन से एलर्जी है, और आपकी पत्नी का नंबर। यही फर्क पड़ता है।",
      uc1Stat: "भारत में हर साल 1.5 लाख से अधिक सड़क मौतें",
      uc2Title: "अकेले रहने वाले बुजुर्ग माता-पिता",
      uc2Desc:
        "आपके पिता रोज़ 4 दवाएं लेते हैं और दूसरे शहर में रहते हैं। अगर वे बाज़ार में गिर जाएं, तो उनकी कलाई पर QR लॉकेट किसी को भी बता देगा कि किसे फोन करना है और उनकी कौन सी दवाएं चल रही हैं।",
      uc2Stat: "भारत में 10 करोड़ से अधिक वरिष्ठ नागरिक",
      uc3Title: "आपका बच्चा खो जाता है",
      uc3Desc:
        "भीड़ भरे मेले या मॉल में आपका बच्चा भटक जाता है। एक अजनबी उन्हें ढूंढता है, उनके बैग या कंगन पर QR कोड स्कैन करता है और सेकंडों में आपको फोन करता है। पुलिस स्टेशन या लाउडस्पीकर की जरूरत नहीं।",
      uc3Stat: "एक माता-पिता का सबसे बड़ा डर, सरलता से हल",
      uc4Title: "मधुमेह, हृदय रोग और एलर्जी",
      uc4Desc:
        "आप मधुमेह के मरीज़ हैं और ऑफिस में बेहोश हो जाते हैं। इस QR कोड के बिना, साथी आपको चीनी का पानी दे सकते हैं जबकि आपको इंसुलिन चाहिए। इसके साथ, उन्हें पता चल जाता है कि क्या गलत है और किसे बुलाना है।",
      uc4Stat: "भारत में अकेले 7.7 करोड़ से अधिक मधुमेह रोगी",
      protectCta: "खुद को बचाएं",
      knowMore: "और जानें",
      uc1Detail:
        "भारत में हर साल 1.5 लाख से अधिक लोग सड़क दुर्घटनाओं में जान गंवाते हैं। ज्यादातर मामलों में पीड़ित बेहोश होता है और महत्वपूर्ण चिकित्सा जानकारी नहीं बता पाता। आपके वाहन या हेलमेट पर EmergencyQR स्टिकर किसी भी राहगीर को तुरंत आपका ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क देखने देता है।",
      uc2Detail:
        "भारत में 10 करोड़ से अधिक वरिष्ठ नागरिक अकेले रहते हैं। कई रोज़ कई दवाएं लेते हैं। उनके पास QR कोड लॉकेट या स्टिकर होने से, अगर वे बाज़ार या पार्क में गिर जाएं, तो कोई भी स्कैन करके जान सकता है कि किसे फोन करना है और कौन सी दवाएं चल रही हैं।",
      uc3Detail:
        "भीड़ में बच्चे का खो जाना हर माता-पिता का डर है। बच्चे के बैग या कंगन पर EmergencyQR स्टिकर लगाने से, कोई भी अच्छा इंसान QR कोड स्कैन करके सेकंडों में आपको फोन कर सकता है।",
      uc4Detail:
        "भारत में 7.7 करोड़ लोगों को मधुमेह है, और लाखों हृदय रोग, गंभीर एलर्जी या मिर्गी से जूझ रहे हैं। आपातकाल में गलत प्राथमिक चिकित्सा जानलेवा हो सकती है। EmergencyQR स्टिकर सुनिश्चित करता है कि आपकी मदद करने वाला जानता है कि क्या गलत है और क्या नहीं करना है।",
    },
    features: {
      sectionTitle: "फीचर्स",
      sectionSubtitle: "जब कुछ गलत हो जाता है, तो सही समय पर सही जानकारी जान बचा सकती है।",
      f1Title: "स्कैन करें और देखें — बस",
      f1Desc:
        "कोई राहगीर या पैरामेडिक अपने फोन कैमरे को आपके QR कोड पर करता है। आपका ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क तुरंत उनकी स्क्रीन पर दिख जाते हैं। कोई ऐप डाउनलोड नहीं, साइनअप नहीं, समय बर्बाद नहीं।",
      f2Title: "सभी चिकित्सा विवरण एक जगह",
      f2Desc:
        "ब्लड ग्रुप, दैनिक दवाएं, दवा एलर्जी, पुरानी बीमारियां, डॉक्टर का नंबर — अस्पताल को आपका सही इलाज करने के लिए जो कुछ चाहिए, सब एक सुरक्षित प्रोफाइल में जो आप नियंत्रित करते हैं।",
      f3Title: "24/7 काम करता है, तब भी जब आप नहीं कर सकते",
      f3Desc:
        "आपातकाल समय नहीं देखता। रात 3 बजे हो या छुट्टी के दिन, आपका QR कोड हमेशा तैयार रहता है। जब तक स्कैन करने वाले के पास फोन और इंटरनेट है, आपकी जानकारी उपलब्ध है।",
      f4Title: "आप तय करते हैं क्या दिखे",
      f4Desc:
        "सब कुछ सार्वजनिक साझा करने में सहज नहीं? कोई बात नहीं। आप तय करते हैं कि स्कैन करने वाले को कौन सी जानकारी दिखे और कौन सी आपके पासवर्ड के पीछे निजी रहे। आपका डेटा एन्क्रिप्टेड है और आपकी अनुमति के बिना कभी साझा नहीं किया जाता।",
      f5Title: "हर परिवार के सदस्य के लिए एक",
      f5Desc:
        "अपने माता-पिता, बच्चों या जिसकी भी आप चिंता करते हैं उनके लिए QR कोड लें। हर व्यक्ति को अपनी चिकित्सा जानकारी के साथ अपना प्रोफाइल मिलता है। यह आपके प्रियजनों की देखभाल का सबसे आसान तरीका है।",
      f6Title: "जीरो ऐप। जीरो झंझट।",
      f6Desc:
        "आपकी मदद करने वाले को कुछ डाउनलोड करने की जरूरत नहीं। हर आधुनिक स्मार्टफोन अपने कैमरे से QR कोड स्कैन कर सकता है। एक स्कैन से आपकी जानकारी वाला एक साधारण पेज खुलता है — इतना आसान।",
      f1DetailDesc:
        "एक स्कैन से आपका ब्लड ग्रुप, एलर्जी, दवाइयाँ और इमरजेंसी कॉन्टैक्ट्स दिखते हैं — कोई ऐप डाउनलोड नहीं चाहिए। किसी भी स्मार्टफोन ब्राउज़र पर तुरंत काम करता है।",
      f1Cta: "हर सेकंड मायने रखता है। जीवन बचाने वाली जानकारी तुरंत पाएं।",
      f2DetailDesc:
        "ब्लड ग्रुप, एलर्जी, वर्तमान दवाइयाँ, पुरानी बीमारियाँ और सर्जिकल हिस्ट्री स्टोर करें। पैरामेडिक्स को तुरंत सबसे ज़रूरी जानकारी मिलती है।",
      f2Cta: "आपकी मेडिकल हिस्ट्री आपकी जान बचा सकती है। इसे सुरक्षित रूप से स्टोर करें।",
      f3DetailDesc:
        "आपका QR स्टिकर 24/7, 365 दिन काम करता है — बारिश हो या धूप। कोई बैटरी नहीं, कोई चार्जिंग नहीं, स्टिकर पर इंटरनेट की ज़रूरत नहीं।",
      f3Cta: "जब आपको सबसे ज़्यादा ज़रूरत हो, हमेशा तैयार।",
      f4DetailDesc:
        "आप तय करते हैं कि दूसरों को कौन सी जानकारी दिखे। हर फील्ड की विज़िबिलिटी टॉगल करें। आपका डेटा एन्क्रिप्टेड और सुरक्षित है।",
      f4Cta: "आपका डेटा, आपके नियम। पूरा प्राइवेसी कंट्रोल।",
      f5DetailDesc:
        "एक फैमिली अकाउंट में कई QR कोड लिंक करें। बुज़ुर्ग माता-पिता, बच्चों और परिवार के सदस्यों की निगरानी करें — एक ही डैशबोर्ड से।",
      f5Cta: "एक अकाउंट से पूरे परिवार की सुरक्षा करें।",
      f6DetailDesc:
        "कोई ऐप डाउनलोड नहीं, स्कैनर को अकाउंट नहीं चाहिए। फोन कैमरे वाला कोई भी व्यक्ति स्कैन करके तुरंत इमरजेंसी जानकारी देख सकता है।",
      f6Cta: "संकट में कोई भी इस्तेमाल कर सके, इतना आसान।",
      buyNow: "अभी खरीदें",
      getYoursCta: "अपना लें",
    },
    landing: {
      activeTitle: "आपातकालीन QR सक्रिय",
      viewInfo: "जानकारी देखें",
      ownerLogin: "मालिक लॉगिन",
      editInfo: "जानकारी संपादित करें",
      matchHolder: "QR कोड धारक से मिलान करें",
      matchHolderHint: "आपातकालीन जानकारी साझा करने से पहले सुनिश्चित करें कि व्यक्ति इस फ़ोटो से मेल खाता है",
    },
    login: {
      title: "लॉग इन",
      password: "पासवर्ड",
      passwordRequired: "पासवर्ड आवश्यक है",
      forgotPassword: "पासवर्ड भूल गए?",
      loggingIn: "लॉग इन हो रहा है...",
      alreadyLoggedIn: "आप पहले से लॉग इन हैं",
    },
    forgotPassword: {
      title: "पासवर्ड भूल गए?",
      emailTab: "ईमेल लिंक",
      phoneTab: "फोन OTP",
    },
    emergencyInfo: {
      title: "आपातकालीन जानकारी",
      previewPublic: "पब्लिक व्यू देखें",
      dragReorder: "क्रम बदलने के लिए खींचें। दृश्यता टॉगल करें।",
      noItemsYet: '"फ़ील्ड जोड़ें" पर क्लिक करके जानकारी जोड़ें।',
      addField: "फ़ील्ड जोड़ें",
    },
    scanner: {
      scanTab: "स्कैन",
      loginTab: "लॉगिन",
      qrIdOrPhone: "QR कोड ID या मोबाइल नंबर",
      scanTitle: "QR कोड स्कैन करें या दर्ज करें",
    },
    profile: {
      title: "मेरी प्रोफाइल",
      linkedQR: "लिंक किए गए QR कोड",
      orderHistory: "ऑर्डर इतिहास",
      noOrders: "अभी तक कोई ऑर्डर नहीं",
      noQR: "अभी तक कोई QR कोड लिंक नहीं",
    },
    pricing: {
      title: "मूल्य निर्धारण",
      oneTimeTab: "QR कोड और स्टिकर",
      premiumTab: "प्रीमियम सदस्यता",
      oneTimeDesc: "अपने QR कोड स्टिकर और 1 साल के प्रीमियम फीचर्स शामिल पाएं।",
      premiumDesc: "उन्नत फीचर्स अनलॉक करें: स्कैन नोटिफिकेशन, दस्तावेज़ अपलोड, ऑफलाइन एक्सेस और प्राथमिकता सहायता।",
      oneTimeLabel: "एक बार",
      orderCta: "अभी ऑर्डर करें",
      bestValue: "सर्वोत्तम मूल्य",
      perYear: "/वर्ष",
      plans: {
        individual: {
          name: "इंडिविजुअल",
          desc: "1 QR कोड ID के साथ 2 स्टिकर (1x1 इंच)",
          f1: "1 यूनिक QR कोड ID",
          f2: "2 वाटरप्रूफ स्टिकर",
          f3: "1 साल प्रीमियम फीचर्स मुफ्त",
          f4: "असीमित आपातकालीन जानकारी फील्ड",
          f5: "मुफ्त शिपिंग",
        },
        family: {
          name: "फैमिली पैक",
          desc: "4 QR कोड IDs के साथ 8 स्टिकर (1x1 इंच)",
          f1: "4 यूनिक QR कोड IDs",
          f2: "8 वाटरप्रूफ स्टिकर (2 प्रति ID)",
          f3: "1 साल प्रीमियम फीचर्स मुफ्त",
          f4: "माता-पिता, बच्चों और खुद को सुरक्षित रखें",
          f5: "मुफ्त शिपिंग",
        },
        premium_yearly: {
          name: "प्रीमियम",
          desc: "आपके आपातकालीन QR कोड के लिए उन्नत फीचर्स",
          f1: "असीमित जानकारी फील्ड",
          f2: "स्कैन नोटिफिकेशन",
          f3: "दस्तावेज़ अपलोड",
          f4: "ऑफलाइन कैशिंग",
          f5: "प्राथमिकता सहायता",
        },
        family_yearly: {
          name: "फैमिली प्रीमियम",
          desc: "4 QR कोड IDs तक के लिए प्रीमियम फीचर्स",
          f1: "असीमित जानकारी फील्ड (4 QR IDs)",
          f2: "स्कैन नोटिफिकेशन",
          f3: "दस्तावेज़ अपलोड",
          f4: "ऑफलाइन कैशिंग",
          f5: "प्राथमिकता सहायता",
        },
      },
    },
    comingNext: {
      title: "जल्द आ रहा है",
      subtitle: "आपको और आपके परिवार को सुरक्षित रखने के और तरीके।",
      locketTitle: "प्रीमियम मेटैलिक लॉकेट",
      locketDesc: "आपके QR कोड के साथ टिकाऊ, पानी प्रतिरोधी चेन। बुजुर्ग माता-पिता के लिए बिल्कुल सही।",
      launchingSoon: "जल्द लॉन्च",
    },
    testimonials: {
      badge: "वास्तविक प्रभाव",
      title: "जान बचाने वाली कहानियाँ।",
    },
    ctaSection: {
      title: "आज ही अपना QR कोड पाएं",
      subtitle: "एक बार खरीदें। जीवन भर इस्तेमाल। 2 मिनट में सेट अप।",
      orderButton: "ऑर्डर",
    },
    public: {
      medicalInfoTitle: "आपातकालीन जानकारी",
      quickActions: "त्वरित कार्रवाई",
      moreOptions: "अधिक विकल्प",
      reportEmergency: "आपातकाल रिपोर्ट करें",
      contactThisPerson: "इस व्यक्ति से संपर्क करें",
      ownerOfLocket: "इस लॉकेट के मालिक",
      ownerValidationNote: "नीचे दी गई आपातकालीन जानकारी पढ़ने से पहले सुनिश्चित करें कि यही वह व्यक्ति है।",
      owner: "मालिक",
      editInformation: "जानकारी संपादित करें",
      noDetailsTitle: "अभी तक कोई विवरण नहीं जोड़ा गया",
      noDetailsDesc:
        "इस QR कोड के मालिक ने अभी तक कोई आपातकालीन जानकारी नहीं जोड़ी। यदि आप मालिक हैं, तो अपनी जानकारी जोड़ने के लिए लॉग इन करें।",
      loadingDetails: "चिकित्सा जानकारी लोड हो रही है...",
      errorTitle: "कुछ गलत हो गया",
      footerTagline: "EmergencyQR.in | DPDPA 2023 | 112 India",
      reportDisclaimerIntro:
        "यह विकल्प केवल वास्तविक आपातकाल की स्थिति में चुनें, न कि मज़ाक या दुरुपयोग के लिए। गलत रिपोर्ट के कानूनी परिणाम हो सकते हैं।",
      reportDisclaimerLegal: "यह विकल्प केवल वास्तविक आपातकाल में चुनें। गलत रिपोर्ट के गंभीर परिणाम हो सकते हैं।",
      govRecognitionTitle: "सरकारी मान्यता और पुरस्कार",
      govRecognitionDesc: "वास्तविक रिपोर्ट से जान बच सकती है और सरकारी मान्यता व पुरस्कार के योग्य हो सकते हैं।",
      understandReport: "मैं समझ गया, रिपोर्ट करें",
      logout: "लॉगआउट",
    },
    emergency: {
      reportTitle: "आपातकाल रिपोर्ट करें",
      reportSubtitle: "आपातकाल की रिपोर्ट करें",
      step1: "स्थान की पुष्टि करें",
      step2: "आपातकाल का प्रकार",
      step3: "साक्ष्य रिकॉर्ड करें",
      step4: "आपका फोन नंबर",
      medical: "चिकित्सा",
      accident: "दुर्घटना",
      fire: "आग / अन्य",
      capturingLocation: "आपका स्थान प्राप्त कर रहे हैं...",
      locationCaptured: "स्थान सफलतापूर्वक प्राप्त हुआ",
      locationFailed: "स्थान प्राप्त नहीं हो सका। कृपया मैन्युअल रूप से दर्ज करें।",
      videoReward:
        "मुफ्त QR कोड, 3 महीने की सदस्यता और सरकारी राह-वीर पुरस्कार Rs.25,000 के लिए 10 सेकंड का वीडियो रिकॉर्ड करें",
      phoneRequired: "कॉलबैक और पुरस्कार दावे के लिए फोन नंबर आवश्यक",
      submitReport: "आपातकालीन रिपोर्ट जमा करें",
      needLocationDesc: "आपातकालीन सेवाओं को तुरंत भेजने के लिए हमें आपका स्थान चाहिए।",
      manualAddressLabel: "पता मैन्युअल रूप से दर्ज करें (वैकल्पिक)",
      manualAddressPlaceholder: "लैंडमार्क, सड़क का नाम या इलाका दर्ज करें...",
      nextSelectType: "अगला - आपातकाल प्रकार चुनें",
      tryAgain: "पुनः प्रयास करें",
      selectTypeDesc: "प्रकार चुनने पर नंबर डायल होगा। अभी कॉल करने के लिए टैप करें।",
      callInitiated: "कॉल शुरू हो गया",
      callInitiatedTo: "कॉल शुरू हो गया",
      continueNext: "अगले चरण पर जाएं →",
      recordEvidenceOptional: "साक्ष्य रिकॉर्ड करें (वैकल्पिक)",
      earnRewards: "पुरस्कार कमाएं!",
      startRecording: "रिकॉर्डिंग शुरू करें",
      stopRecording: "रिकॉर्डिंग रोकें",
      recordAgain: "फिर से रिकॉर्ड करें",
      videoRecorded: "वीडियो सफलतापूर्वक रिकॉर्ड हुआ!",
      tapToStartRecording: "10 सेकंड की रिकॉर्डिंग शुरू करने के लिए नीचे टैप करें",
      cameraDenied: "कैमरा एक्सेस अस्वीकृत या अनुपलब्ध।",
      skip: "छोड़ें",
      next: "अगला",
      yourPhoneNumber: "आपका फोन नंबर",
      phoneRequiredDesc: "कॉलबैक सत्यापन और पुरस्कार दावे के लिए आवश्यक।",
      phoneLabel: "फोन नंबर",
      enterPhonePlaceholder: "10 अंकों का नंबर दर्ज करें",
      phonePrivacyNote: "आपका नंबर केवल आपातकालीन कॉलबैक और पुरस्कार सत्यापन के लिए उपयोग किया जाएगा।",
      submitting: "जमा हो रहा है...",
      reportSubmitted: "रिपोर्ट जमा हो गई",
      redirecting: "प्राथमिक चिकित्सा मार्गदर्शन पर रीडायरेक्ट हो रहा है...",
      rahVeerEligible: "राह-वीर पुरस्कार के पात्र!",
      rewardAmount: "Rs.25,000 + कानूनी प्रतिरक्षा",
      emergency112: "112 आपातकाल",
      locationUnavailable: "स्थान अनुपलब्ध",
      submitError: "रिपोर्ट जमा करने में विफल। कृपया पुनः प्रयास करें।",
      phoneValidationDigits: "फोन नंबर 10 अंकों का होना चाहिए",
      phoneValidationStart: "6, 7, 8 या 9 से शुरू होना चाहिए",
      indiaEmergencyNumbers: "भारत आपातकाल नंबर:",
      number112Desc: "112 — राष्ट्रीय एकल आपातकाल नंबर (दुर्घटना, बचाव, कोई आपातकाल)",
      number108Desc: "108 — एम्बुलेंस (चिकित्सा आपातकाल)",
      number100Desc: "100 — पुलिस",
    },
    rescue: {
      title: "प्राथमिक चिकित्सा मार्गदर्शन",
      subtitle: "एम्बुलेंस की प्रतीक्षा करते हुए इन चरणों का पालन करें",
      rewardBanner: "आप राह-वीर के रूप में कार्य कर रहे हैं! Rs.25,000 पुरस्कार + कानूनी प्रतिरक्षा के पात्र",
      danger: "खतरा",
      dangerDesc: "जांचें कि क्या क्षेत्र आपके पास जाने के लिए सुरक्षित है। यातायात, आग या बिजली के खतरों की तलाश करें।",
      response: "प्रतिक्रिया",
      responseDesc: "धीरे से व्यक्ति के कंधों को थपथपाएं और जोर से पूछें: 'क्या आप ठीक हैं? क्या आप मुझे सुन सकते हैं?'",
      airway: "वायुमार्ग",
      airwayDesc: "सिर को धीरे से पीछे झुकाएं और ठुड्डी को ऊपर उठाएं। मुंह से दिखाई देने वाली किसी भी रुकावट को हटाएं।",
      breathing: "श्वास",
      breathingDesc: "10 सेकंड तक छाती की गति देखें, सांस की आवाज सुनें, और अपने गाल पर हवा महसूस करें।",
      circulation: "रक्त संचार",
      circulationDesc: "गंभीर रक्तस्राव की जांच करें। यदि खून बह रहा है, तो साफ कपड़े से मजबूत, निरंतर दबाव लगाएं।",
      cprTitle: "सीपीआर निर्देश",
      cprDesc: "यदि सांस नहीं चल रही: छाती के बीच में जोर से और तेज दबाएं। 30 दबाव, फिर 2 बचाव श्वास। दोहराएं।",
      bleedingTitle: "रक्तस्राव नियंत्रण",
      bleedingDesc: "साफ कपड़े से सीधा, निरंतर दबाव लगाएं। कपड़ा न हटाएं। जरूरत हो तो और परतें जोड़ें।",
      fractureTitle: "फ्रैक्चर सहायता",
      fractureDesc: "घायल अंग को लकड़ी के ब्लॉक, छतरी या मुड़े हुए अखबार से सहारा दें। अंग को सीधा करने की कोशिश न करें।",
      neckWarning:
        "बेहोश व्यक्ति को गर्दन को सहारा दिए बिना कभी न हिलाएं। रीढ़ की हड्डी की चोटें स्थायी पक्षाघात का कारण बन सकती हैं।",
      completed: "पूरा हुआ",
      primarySurveyTitle: "प्राथमिक सर्वेक्षण (DRABC)",
      primarySurveySubtitle: "प्रत्येक चरण का क्रम में पालन करें",
      criticalInterventions: "महत्वपूर्ण हस्तक्षेप",
      goldenHourSubtitle: "गोल्डन ऑवर कार्रवाइयां",
      markAsDone: "पूरा हुआ मार्क करें",
      rewardEligibleShort: "Rs.25,000 पुरस्कार + पूर्ण कानूनी प्रतिरक्षा के पात्र",
      completeMoreSteps: "राह-वीर स्थिति के लिए {{n}} और चरण पूरे करें",
      disclaimer:
        "MoHFW और सेंट जॉन एम्बुलेंस प्रोटोकॉल के आधार पर निर्देश। संदेह की स्थिति में, पेशेवर मदद की प्रतीक्षा करें।",
      poweredBy: "EmergencyQR.in द्वारा संचालित",
      typeMedical: "चिकित्सा आपातकाल — CPR और श्वास पर ध्यान दें",
      typeAccident: "दुर्घटना — रक्तस्राव नियंत्रण पर ध्यान दें",
      typeFire: "आग/अन्य — जलने और रक्तस्राव की जांच करें",
      whatsappNotify: "WhatsApp से सूचित करें",
    },
    faq: {
      badge: "और जानें",
      title: "अक्सर पूछे जाने वाले प्रश्न",
      q1: "EmergencyQR कैसे काम करता है?",
      a1: "आपको एक टिकाऊ QR स्टिकर मिलता है जिसे आप अपने वाहन, हेलमेट या आईडी कार्ड पर लगाते हैं। जब कोई स्कैन करता है तो आपकी आपातकालीन चिकित्सा जानकारी, संपर्क और 112, 108 (एम्बुलेंस) और 100 (पुलिस) पर कॉल करने का एक-टैप एक्सेस दिखता है।",
      q2: "मुझे अपने प्रोफाइल में कौन सी जानकारी जोड़नी चाहिए?",
      a2: "हम ब्लड ग्रुप, ज्ञात एलर्जी, चिकित्सा स्थितियां (मधुमेह, हृदय रोग आदि), फोन नंबर के साथ आपातकालीन संपर्क और अपने पसंदीदा अस्पताल को जोड़ने की सलाह देते हैं। आप नियंत्रित करते हैं कि स्कैनर को क्या दिखे।",
      q3: "क्या मेरा चिकित्सा डेटा सुरक्षित है?",
      a3: "सभी चिकित्सा डेटा आराम के समय AES-256-GCM एन्क्रिप्शन से सुरक्षित है। हम DPDPA 2023 (भारत का डेटा संरक्षण अधिनियम) का पालन करते हैं। आप प्रत्येक जानकारी की दृश्यता नियंत्रित कर सकते हैं और किसी भी समय अपना प्रोफाइल हटा सकते हैं।",
      q4: "राह-वीर पुरस्कार क्या है?",
      a4: "भारत के गुड समैरिटन नियमों के तहत, दुर्घटना पीड़ित की मदद करने वाला कोई भी राहगीर सरकार से Rs.25,000 नकद पुरस्कार और पूर्ण कानूनी प्रतिरक्षा के पात्र है। हमारा ऐप पुरस्कार सत्यापन के लिए आपकी गुड समैरिटन कार्रवाइयों को दस्तावेज़ करने में मदद करता है।",
      q5: "क्या मैं अपने परिवार के लिए प्रोफाइल प्रबंधित कर सकता हूं?",
      a5: "हां। हमारा फैमिली डैशबोर्ड आपको एक लॉगिन से बुजुर्ग माता-पिता, बच्चों और जीवनसाथी के लिए आपातकालीन प्रोफाइल प्रबंधित करने देता है। हर सदस्य को अपना QR स्टिकर मिलता है जो उनके व्यक्तिगत प्रोफाइल से जुड़ा होता है।",
      q6: "इसकी लागत कितनी है?",
      a6: "व्यक्तिगत स्टिकर सिर्फ Rs.99 से शुरू होते हैं जिसमें 12 महीने के प्रीमियम फीचर्स शामिल हैं। फैमिली पैक (4 स्टिकर) Rs.249 में। कोई छिपी फीस नहीं, पहले साल के लिए कोई आवर्ती शुल्क नहीं।",
    },
    shared: {
      loading: "लोड हो रहा है...",
      error: "कुछ गलत हो गया",
      back: "वापस",
      next: "अगला",
      submit: "जमा करें",
      cancel: "रद्द करें",
      save: "सहेजें",
      delete: "हटाएं",
      edit: "संपादित करें",
      close: "बंद करें",
      poweredBy: "EmergencyQR.in द्वारा संचालित",
    },
  },
};

export const t = (key, lang = "en") => {
  const keys = key.split(".");
  let result = translations[lang];
  for (const k of keys) {
    if (result && result[k] !== undefined) {
      result = result[k];
    } else {
      result = translations.en;
      for (const fallbackKey of keys) {
        if (result && result[fallbackKey] !== undefined) {
          result = result[fallbackKey];
        } else {
          return key;
        }
      }
      return result;
    }
  }
  return result;
};

export const getBilingual = (enKey, hiKey, lang = "en") => {
  const en = t(enKey, "en");
  const hi = t(hiKey || enKey, "hi");
  if (lang === "both") return { en, hi };
  return lang === "hi" ? hi : en;
};

export default translations;
